import React from 'react';
import { Box, Button, TextField, Select, MenuItem, FormControl } from "@mui/material";
import { useCallback, useMemo, useState, useEffect } from 'react';
import { CompaniesProvider } from '../../../store/companies-context';
import axios from "../../../utils/fvAxios";
import AddIcon from "@mui/icons-material/Add";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

import { IconButton } from '@mui/material'

import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ToastContainer, toast } from "react-toastify";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { styled } from '@mui/system';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import { buttonUnstyledClasses } from '@mui/base/ButtonUnstyled';
import TabUnstyled, { tabUnstyledClasses } from '@mui/base/TabUnstyled';
import PrequalRequired from './PrequalRequired';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";


const white = {
  50: '#fff',
  100: '#fff',
  200: '#fff',
  300: '#fff',
  400: '#fff',
  500: '#F2F4F7',
  600: '#030202',
  700: '#0059B2',
  800: '#fff',
  900: '#fff',
};

const Tab = styled(TabUnstyled)`
  font-family: IBM Plex Sans, sans-serif;
  color: black;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: transparent;
  width: 100%;
  padding: 10px 5px;
  margin: 6px 6px;
  border: none;
  border-radius: 5px;
  display: flex;
  justify-content: center;

  &:hover {
    background-color: ${white[400]};
  }

  &:focus {
    color: #fff;
    border-radius: 3px;
    outline: 2px solid ${white[200]};
    outline-offset: 2px;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: ${white[50]};
    color: ${white[600]};
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
`;

const TabsList = styled(TabsListUnstyled)`
  min-width: 320px;
  background-color: ${white[500]};
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
`;


export default function EditClientPreq({ org }) {

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [intro, setIntro] = useState([]);
  const [index, setIndex] = React.useState(0);
  const [alignment, setAlignment] = React.useState("");

  const handleChange = (newAlignment, i) => {
    setAlignment(newAlignment);
    setIndex(i);
  };


  useEffect(() => {
    axios.get("Companies/GetTemplateDetails?organizationId=" + org
    ).then((res) => {
      if (res?.data?.responseCode === 100) {
        const data = res?.data?.data;
        setIntro(data)
        setAlignment(data[0]?.value);
        setSelectedValue(data[0]?.value);
      }
      else {
        setError(res?.data?.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setIsLoading(false);
    });


  }, []);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSectionValue("");
    setBody("");
  };

  const [selectedValue, setSelectedValue] = useState('');
  const [refresh, setRefresh] = useState(false);
  const [SectionValue, setSectionValue] = useState('');
  const [email, setEmail] = useState('');
  const [registration, setRegistration] = useState('0');
  const [Body, setBody] = useState("");

  const handleChange1 = (event) => {
    setSelectedValue(event?.target?.value);
  };
  const ChangeBody = (data) => {
    setBody(data);
  }

  const handleSubmit = (event) => {
    event?.preventDefault();

    if (!selectedValue || !Body || !SectionValue) {
      toast.error("Please fill all the mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    } else {
      setIsLoading(true);
      handleClose();
      const data = {
        clientTemplateProfileId: 0,
        organizationID: Number(org),
        templateID: selectedValue,
        templateName: "",
        prequalRequirementTitle: SectionValue,
        prequalRequirementContent: Body
      }
      axios
        .post("Companies/AddNewPrequalRequirement", data,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((res) => {
          setOpen(false);
          if (res?.data?.responseCode == "100") {

            toast.success(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setRefresh(!refresh)

          } else {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            // setOpen(false);
          }

        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

  };
  const formats = [
    "strike",
    "size",
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'background',
    'list',
    'align',

    // 'image',
    'color',
    'indent',
    'clean',
    'blockquote', 'script'

  ];

  const modules = {
    toolbar: [
      ['undo', 'redo'],
      [{ 'size': [] }],
      [{ 'font': [] }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],

      ['clean'],

      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
    ],
  };



  const handleUndo = () => {
    const quill = quillRef.current.getEditor();
    quill.history.undo();
  };

  const handleRedo = () => {
    const quill = quillRef.current.getEditor();
    quill.history.redo();
  };
  const quillRef = React.createRef();
  return (
    <>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{ padding: "48px 48px" }} >
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          >
            <span style={{ fontSize: "larger" }} >Add Prequalification Requirements</span>
          </DialogTitle>
          <DialogActions >
            <div>
              <DialogActions >
                <div>
                  <div className='mt-3' >
                    <span style={{ color: "#3E4A62" }}>Template<span style={{ color: "red" }}>*</span></span>
                    <br />
                    <Select sx={{
                      width: "100%", minWidth: "",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },

                      fontFamily: "Arial, FontAwesome",
                    }}

                      size="small" value={selectedValue} onChange={handleChange1}>
                      {intro?.map((option) => (
                        <MenuItem key={option?.value} value={option?.value}>
                          {option?.text}
                        </MenuItem>
                      ))}
                    </Select>

                  </div>

                  <div className='mt-3'>
                    <span style={{ color: "#3E4A62" }}> Title</span>
                    <br />
                    <TextField

                      placeholder="Section Name"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "100%",
                        backgroundColor: "#fff",
                        marginTop: "2px",
                        marginBottom: "5px",
                      }}

                      variant="outlined"
                      size="small"
                      value={SectionValue || ""}
                      onChange={(e) => setSectionValue(e?.target?.value)}

                    />
                  </div>




                  <br />

                  <span style={{ color: "#3E4A62" }}>Content <span style={{ color: "red" }}>*</span></span>
                  <div style={{ width: "500px" }}>
                    <div>
                      <IconButton onClick={handleUndo} sx={{ marginBottom: "-64px" }}>
                        <UndoIcon />
                      </IconButton>
                      <IconButton onClick={handleRedo} sx={{ marginBottom: "-64px" }}>
                        <RedoIcon />
                      </IconButton>

                      <ReactQuill
                        ref={quillRef}
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        value={Body}
                        onChange={setBody}
                      />
                    </div>
                  </div>
                  <DialogActions >
                    <div className="login-help__buttonContainer mt-4">
                      <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                      <Button variant="contained" className="login-button-request mx-2" onClick={handleSubmit}> Add</Button>
                    </div>

                  </DialogActions>
                </div >
              </DialogActions>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}

      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          paddingLeft: "20px",
          paddingRight: "20px",
          "& hr": { mx: 0.5 },
        }}
      >
        <span
          style={{
            marginRight: "auto",
            textDecoration: "none",
            marginTop: "10px",
            marginBottom: "10px",
            color: "#3E4A62",
          }}
        >
          Intoduction Content
        </span>
        {!HasScreenPermissions(INFO?.AddNewPrequalRequirement?.actionName) &&
          <Button variant="contained" onClick={handleClickOpen}>
            <AddIcon /> Add New
          </Button>
        }
      </Box>

      <div className="row" >
        <CompaniesProvider>
          <TabsUnstyled defaultValue={index} sx={{ backgroundColor: "#fff" }}>
            <TabsList sx={{ width: "auto" }}>

              {intro?.map((r, i) => (
                <Tab key={r?.value} onClick={() => handleChange(r?.value, i)}>{r?.text}</Tab>
              ))}
            </TabsList>

            <TabPanel value={index} ><PrequalRequired Alignments={alignment} orgs={org} refrh={refresh} /></TabPanel>


          </TabsUnstyled>
        </CompaniesProvider>
      </div>


    </>
  )
}
